//Importação React
import React from "react";

export default function FooterSecondary(props) {
  return (
    <>
      <div className={"bg-gray-200 h-14 w-full bottom-0 left-0  " + props.relativePosition}>
        <div className="flex justify-center items-center h-full">
          <div className="mr-9">
            <a
              href="#"
              class="flex-1 text-center text-sm text-gray-600 hover:text-blue-600"
            >
              Fale conosco
            </a>
          </div>
          <div className="mr-9">
            <a
              href="#"
              class="flex-1 text-center text-sm text-gray-600 hover:text-blue-600"
            >
              Privacidade
            </a>
          </div>
          <div>
            <a
              href="#"
              class="flex-1 text-center text-sm text-gray-600 hover:text-blue-600"
            >
              Termos de uso
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
